// 公募基金累计收益
import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';
import Model, { valueWithArray } from 'ducker-model';
import chartTool from '../utils/chart';

// 收益点
const pointProperty = {
  date: String,
  value: String,
  type: String,
};

const pointKeyFromPropertyName = {
  date: 'PDATE',
  value: {
    property: 'YIELD',
    defaultValue: null,
    computed: (value) => (isEmpty(value) ? null : parseFloat(value)),
  },
  type: {
    defaultValue: 'fund-point',
  },
};

const PointModel = new Model(pointProperty, pointKeyFromPropertyName);

// 指数点
const indexProperty = {
  date: String,
  value: String,
  type: String,
};

const indexKeyFromPropertyName = {
  date: 'PDATE',
  value: {
    property: 'INDEXYIELD',
    defaultValue: null,
    computed: (value) => (isEmpty(value) ? null : parseFloat(value)),
  },
  type: {
    defaultValue: 'index-point',
  },
};

const IndexModel = new Model(indexProperty, indexKeyFromPropertyName);

// 同类平均
const typeProperty = {
  date: String,
  value: String,
  type: String,
};

const typeKeyFromPropertyName = {
  date: 'PDATE',
  value: {
    property: 'FUNDTYPEYIELD',
    defaultValue: null,
    computed: (value) => (isEmpty(value) ? null : parseFloat(value)),
  },
  type: {
    defaultValue: 'type-point',
  },
};

const TypeModel = new Model(typeProperty, typeKeyFromPropertyName);

// 业绩比较基准
const benchProperty = {
  date: String,
  value: String,
  type: String,
};

const benchKeyFromPropertyName = {
  date: 'PDATE',
  value: {
    property: 'BENCHQUOTE',
    defaultValue: null,
    computed: (value) => (isEmpty(value) ? null : parseFloat(value)),
  },
  type: {
    defaultValue: 'bench-point',
  },
};

const BenchModel = new Model(benchProperty, benchKeyFromPropertyName);

// Model
const property = {
  pointList: valueWithArray(Object),
  indexPointList: valueWithArray(Object),
  typePointList: valueWithArray(Object),
  benchPointList: valueWithArray(Object),
  extraInfo: Object,
};

const replacedKeyFromPropertyName = {
  pointList: {
    property: 'data',
    computed: (data) => PointModel.objectArrayWithKeyValuesArray(data),
  },
  indexPointList: {
    property: 'data',
    computed: (data) => IndexModel.objectArrayWithKeyValuesArray(data),
  },
  typePointList: {
    property: 'data',
    computed: (data) => TypeModel.objectArrayWithKeyValuesArray(data),
  },
  benchPointList: {
    property: 'data',
    computed: (data) => BenchModel.objectArrayWithKeyValuesArray(data),
  },
  extraInfo: {
    property: 'expansion',
    computed: (expansion) => {
      const aboutAccResponses = expansion?.aboutAcc || []; // 额外数据
      const changeInfo = expansion?.changeInfo || [];
      const maxReturn = expansion?.MAXRETRA || '';
      return {
        indexInfo: aboutAccResponses?.[aboutAccResponses.length - 1] || {},
        changePoints: chartTool.handleChangeInfo(changeInfo),
        maxReturn: chartTool.handleChartMaxReturn(changeInfo, maxReturn),
      };
    },
  },
};

export default new Model(property, replacedKeyFromPropertyName);
